import '../styles/footer.css'
import '../styles/articles.css'

function Footer() {
    return (
        <section id='footer_articles_display'>
            <article id='footer_articles'>
                <div id="footer_left_placement">
                    Copyright © 2025 Gael Delescluse
                </div>
                <div id="footer_right_placement">
                    Built by Gael Delescluse
                </div>
            </article>
            
        </section>
    )
}

export default Footer